import { Grid } from '@mui/material'
import clsx from 'clsx'
import React from 'react'
import HeroHeader from 'src/components/shared/modules/heroHeader/HeroHeader'
import { contentType } from 'src/types/components/shared/atom'
import useStyles from './Style'
interface IProps {
  zenMode: boolean
  content: contentType
}
const HeaderTop: React.FC<IProps> = ({ zenMode, content }) => {
  const { classes } = useStyles()
  return (
    <Grid
      className={clsx(
        classes.rootContainer,
        zenMode && classes.zenRootContainer
      )}
    >
      <HeroHeader heroContent={content} />
    </Grid>
  )
}

export default HeaderTop
